import { useCurrentClient } from '@pbk-web/state';
import { ModuleType } from '@pbk-web/types';
import { LanguageUtils } from '@pbk-web/utils';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ClientTemplateModuleService from '../services/ClientTemplateModuleService';
import ModuleService from '../services/ModuleService';

const useFetchClasses = () => {
  const currentClient = useCurrentClient((x) => x.value);
  const { i18n } = useTranslation();

  const clientTemplateModuleService = useMemo(() => new ClientTemplateModuleService(currentClient!.id), [currentClient]);

  const fetch = useCallback(() => {
    return clientTemplateModuleService.getTemplatesConfigurations(ModuleType.Document).then((templateConfigs) => {
      return ModuleService.getModules().then((res) => {
        res.data.forEach((clientModule) => {
          const moduleTemplate = templateConfigs.data.find((x) => x.templateModule.id === clientModule.templateId);
          if (moduleTemplate) {
            moduleTemplate.clientModuleId = clientModule.id;
            moduleTemplate.clientModuleName = LanguageUtils.getTranslation('name', clientModule.translations, i18n.language);
          }
        });

        return templateConfigs;
      });
    });
  }, [clientTemplateModuleService, i18n.language]);

  return fetch;
};

export default useFetchClasses;
